import { HEX } from '../../../../shared-kernel';
import { ProductDelivery } from '../../../products/types';

type rawType = {
  [key: string]: string | boolean | number | HEX;
} | null;

export const serializeProductDelivery = (
  props: rawType
): ProductDelivery => {
  return { ...props } as ProductDelivery;
};
